import { Switch } from 'antd'
import cn from 'classnames'
import { Props } from './types'
import './switch.default.scss'

export const Default = ({
  className,
  withLabels,
  checkedChildren,
  unCheckedChildren,
  ...props
}: Props) => (
  <Switch
    className={cn('switch-default', className)}
    checkedChildren={withLabels ? checkedChildren ?? 'ON ' : checkedChildren}
    unCheckedChildren={
      withLabels ? unCheckedChildren ?? 'OFF' : unCheckedChildren
    }
    {...props}
  />
)
